import React from "react";
import { Dropdown, Layout, Menu } from "antd";
import {
  QuestionCircleOutlined,
  LogoutOutlined,
  UserOutlined,
} from "@ant-design/icons";

import { useHistory, useLocation } from "react-router-dom";
import "../Styles/Common.less";
import { useDispatch } from "react-redux";
import { logout } from "../Store/authStore";
import { DefaultMenu, NavMenuItems, PortalTitle } from "../Constants/Constants";
import { getCurrentUserFromStorage } from "../Constants/Utilities";

const { SubMenu } = Menu;
const { Header, Content, Sider, Footer } = Layout;

export const MainPage = (props) => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const path = location.pathname?.slice(1)?.split("/") || [];
  const defaultMenu = path[0] || DefaultMenu;
  const [menuItem, setMenuItem] = React.useState(defaultMenu);
  const currentUser = getCurrentUserFromStorage();

  const onMenuClick = (e) => {
    console.log("onMenuChange", e);
    const oldMenu = menuItem;
    setMenuItem(e.key);
    history.push("/" + e.key);
    if (oldMenu === e.key) {
      history.go();
    }
  };

  const onLogout = () => {
    dispatch(logout());
    history.push("/login");
  };

  const userMenu = (
    <Menu>
      <Menu.Item key="logout">
        <div className="logout-button" onClick={onLogout}>
          <span style={{ marginRight: "5px" }}>Logout</span>
          <LogoutOutlined />
        </div>
      </Menu.Item>
    </Menu>
  );

  const mainMenu = (
    <Menu
      mode="inline"
      onClick={onMenuClick}
      defaultSelectedKeys={[menuItem || defaultMenu]}
      style={{ height: "100%" }}
    >
      <Menu.Item
        className="menu-items"
        key={NavMenuItems.serviceProvider.key}
        title={NavMenuItems.serviceProvider.label}
        icon={NavMenuItems.serviceProvider.icon()}
      >
        {NavMenuItems.serviceProvider.label}
      </Menu.Item>
      <Menu.Item
        className="menu-items"
        key={NavMenuItems.service.key}
        title={NavMenuItems.service.label}
        icon={NavMenuItems.service.icon()}
      >
        {NavMenuItems.service.label}
      </Menu.Item>
      <Menu.Item
        className="menu-items"
        key={NavMenuItems.serviceOffering.key}
        title={NavMenuItems.serviceOffering.label}
        icon={NavMenuItems.serviceOffering.icon()}
      >
        {NavMenuItems.serviceOffering.label}
      </Menu.Item>
      <Menu.Item
        className="menu-items"
        key={NavMenuItems.serviceTier.key}
        title={NavMenuItems.serviceTier.label}
        icon={NavMenuItems.serviceTier.icon()}
      >
        {NavMenuItems.serviceTier.label}
      </Menu.Item>
      <Menu.Item
        className="menu-items"
        key={NavMenuItems.deviceModel.key}
        title={NavMenuItems.deviceModel.label}
        icon={NavMenuItems.deviceModel.icon()}
      >
        {NavMenuItems.deviceModel.label}
      </Menu.Item>
      <Menu.Item
        className="menu-items"
        key={NavMenuItems.orderManagement.key}
        title={NavMenuItems.orderManagement.label}
        icon={NavMenuItems.orderManagement.icon()}
      >
        {NavMenuItems.orderManagement.label}
      </Menu.Item>
      <Menu.Item
        className="menu-items"
        key={NavMenuItems.deviceManagement.key}
        title={NavMenuItems.deviceManagement.label}
        icon={NavMenuItems.deviceManagement.icon()}
      >
        {NavMenuItems.deviceManagement.label}
      </Menu.Item>
      <Menu.Item
        className="menu-items"
        key={NavMenuItems.codeManagement.key}
        title={NavMenuItems.codeManagement.label}
        icon={NavMenuItems.codeManagement.icon()}
      >
        {NavMenuItems.codeManagement.label}
      </Menu.Item>
      <SubMenu
        className="menu-items"
        key={NavMenuItems.configuration.key}
        title={NavMenuItems.configuration.label}
        icon={NavMenuItems.configuration.icon()}
      >
        <Menu.Item
          className="menu-items"
          key={NavMenuItems.configuration.serviceProvider.key}
          title={NavMenuItems.configuration.serviceProvider.label}
          icon={NavMenuItems.configuration.icon()}
        >
          {NavMenuItems.configuration.serviceProvider.label}
        </Menu.Item>
        <Menu.Item
          className="menu-items"
          key={NavMenuItems.configuration.service.key}
          title={NavMenuItems.configuration.service.label}
          icon={NavMenuItems.configuration.icon()}
        >
          {NavMenuItems.configuration.service.label}
        </Menu.Item>
        <Menu.Item
          className="menu-items"
          key={NavMenuItems.configuration.deviceModel.key}
          title={NavMenuItems.configuration.deviceModel.label}
          icon={NavMenuItems.configuration.icon()}
        >
          {NavMenuItems.configuration.deviceModel.label}
        </Menu.Item>
        <Menu.Item
          className="menu-items"
          key={NavMenuItems.configuration.group.key}
          title={NavMenuItems.configuration.group.label}
          icon={NavMenuItems.configuration.icon()}
        >
          {NavMenuItems.configuration.group.label}
        </Menu.Item>
        <Menu.Item
          className="menu-items"
          key={NavMenuItems.configuration.device.key}
          title={NavMenuItems.configuration.device.label}
          icon={NavMenuItems.configuration.icon()}
        >
          {NavMenuItems.configuration.device.label}
        </Menu.Item>
      </SubMenu>
      <Menu.Item
        className="menu-items"
        key={NavMenuItems.help.key}
        title={NavMenuItems.help.label}
        icon={<QuestionCircleOutlined />}
      >
        {NavMenuItems.help.label}
      </Menu.Item>
    </Menu>
  );

  return (
    <Layout className="main-page-container">
      <Header className="main-page-header">
        <div className="logo" />
        <div className="username-container">
          <Dropdown overlay={userMenu} placement="bottomCenter">
            <div className="username-dropdown-container">
              <UserOutlined />
              <div className="username">{currentUser?.username}</div>
            </div>
          </Dropdown>
        </div>
        <div className="main-header-title">{PortalTitle}</div>
      </Header>
      <Layout>
        <Sider width={250} className="site-layout-background">
          {mainMenu}
        </Sider>
        <Layout className="main-page-content-layout">
          <Content className="main-page-content">{props.children}</Content>
          <Footer className="main-page-footer">
            ©2021 CommScope Inc. All rights reserved.
          </Footer>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default MainPage;
